import { graphql, Link } from 'gatsby';
import kebabCase from 'lodash/kebabCase';
import React from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import config from '../../config/SiteConfig';
import { Content, Header, Layout, PrevNext, SectionTitle, SEO, Subline, Wrapper } from '../components';
import PathContext from '../models/PathContext';
import Post from '../models/Post';
import '../utils/prismjs-theme.css';

const PostContent = styled.div`
  margin-top: 4rem;
`;

interface Props {
  data: {
    markdownRemark: Post;
  };
  pathContext: PathContext;
}

export default class PostPage extends React.PureComponent<Props> {
  public render() {
    const { prev, next } = this.props.pathContext;
    const post = this.props.data.markdownRemark;
    const authors =
      post &&
      post.frontmatter.authors &&
      post.frontmatter.authors.reduce((acc: { name: string; url: string }[], txt: string) => {
        const arr = txt.split('|');
        acc.push({ name: arr[0], url: arr[1] ? arr[1] : '/' });
        return acc;
      }, []);
    return (
      <Layout>
        {post ? (
          <>
            <SEO postPath={post.fields.slug} postNode={post} postSEO />
            <Helmet title={`${post.frontmatter.title} | ${config.siteTitle}`} />
            <Header banner={post.frontmatter.banner}>
              <SectionTitle>{post.frontmatter.title}</SectionTitle>
              <Subline light={true}>
                {post.frontmatter.date} &mdash; {post.timeToRead} Min Read &mdash; In{' '}
                <Link to={`/categories/${kebabCase(post.frontmatter.category)}`}>{post.frontmatter.category}</Link>
              </Subline>
            </Header>
            <Wrapper>
              <Content>
                {authors ? (
                  <Subline>
                    {authors.length > 1 ? `Authors` : `Author`}: &#160;
                    {authors.map((author, i) => (
                      <strong key={i}>
                        {author.name} {i < authors.length - 1 ? `, ` : ``}
                      </strong>
                    ))}
                  </Subline>
                ) : null}
                <PostContent dangerouslySetInnerHTML={{ __html: post.html }} />
                {post.frontmatter.tags ? (
                  <Subline>
                    Tags: &#160;
                    {post.frontmatter.tags.map((tag, i) => (
                      <Link key={i} to={`/tags/${kebabCase(tag)}`}>
                        <strong>{tag}</strong> {i < post.frontmatter.tags.length - 1 ? `, ` : ``}
                      </Link>
                    ))}
                  </Subline>
                ) : null}
                <PrevNext prev={prev} next={next} />
              </Content>
            </Wrapper>
          </>
        ) : null}
      </Layout>
    );
  }
}
export const PostQuery = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      fields {
        slug
      }
      frontmatter {
        title
        date(formatString: "DD.MM.YYYY")
        category
        tags
        banner
        authors
      }
      timeToRead
    }
  }
`;
